import React, { useRef } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

export type InputType = "TEXT" | "CHECKBOX" | "DROPDOWN";

export type TerminalCommandInputType = {
  key: string;
  inputType: InputType;
  // used only if the input type is DROPDOWN
  inputOptions?: string[];
  label: string;
  required: boolean;
  default?: any;
  description?: string;
};

const TerminalCommandInput = (props: {
  input: TerminalCommandInputType;
  value: any;
  onUpdate: (key: string, value: string | boolean) => void;
}) => {
  if (props.input.inputType === "CHECKBOX") {
    const [checked, setChecked] = React.useState(props.input.default === true);
    if (!!props.value != checked) {
      setChecked(!!props.value);
    }
    return (
      <>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={() => {
                console.log("checked onChange old" + checked);
                props.onUpdate(props.input.key, !checked);
                setChecked(!checked);
              }}
              name="checkedB"
            />
          }
          label={props.input.label}
        />
      </>
    );
  } else if (props.input.inputType === "TEXT") {
    const textRef = React.useRef("");
    return (
      <div>
        <form className="terminalCommandClass" noValidate autoComplete="off">
          <TextField
            value={props.value}
            key={`textbox_${props.input.label}`}
            inputRef={textRef}
            style={{ width: "300px" }}
            id="outlined-basic"
            label={props.input.label}
            variant="outlined"
            required={true}
            onChange={(event) => {
              props.onUpdate(props.input.key, event.target.value);
            }}
          />
        </form>
        <br />
      </div>
    );
  } else if (props.input.inputType === "DROPDOWN") {
    if (
      props.input.inputOptions === undefined ||
      props.input.inputOptions.length === 0
    ) {
      return <p>Error No inputOptions provided.</p>;
    }

    const [dropdownInput, setDropdownInput] = React.useState("");
    return (
      <FormControl
        variant="outlined"
        className="autocomplete-form"
        style={{ width: "300px" }}
      >
        <InputLabel htmlFor="outlined-age-native-simple">
          {props.input.label}
        </InputLabel>
        <Select
          value={dropdownInput}
          onChange={(event: any) => {
            setDropdownInput(event.target.value);
            props.onUpdate(props.input.key, event.target.value);
          }}
          label={props.input.label}
        >
          {props.input.inputOptions.map((field) => {
            console.log(field);
            return (
              <MenuItem key={field} value={field}>
                {field}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  } else {
    return <p>Not supported input Type {props.input.inputType}</p>;
  }
};

export default TerminalCommandInput;
